import styled from 'styled-components'
import { Box } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'

export const EmployeesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
`

export const EmployeesTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
  color: ${tokens.text.primary};
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex: none;
`

export const KpiBand = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1.5rem;

  @media (max-width: 1020px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const NameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const NameTitle = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 500;
  color: ${tokens.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const NameRole = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const MutedCell = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  white-space: nowrap;
`

export const AvatarThumb = styled.div`
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  overflow: hidden;
  flex: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.secondary};
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const StatusCircle = styled.div`
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.6rem;
  background: ${(props) => props.color};
  border-radius: 50%;
`

export const ImageModalFrame = styled.div`
  max-height: 30vh;
  max-width: 40vw;
  height: 30vh;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    object-fit: contain;
  }
`

export const ContractInputWrapper = styled.div`
  
  display: flex;
  flex-direction:column;
  gap:1rem;
  width:100%;
  
  @media (max-width: 500px) {
  
    width:100%;
  }

`

export const ContractShiftsContainer = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  gap:1rem;
  margin-top: 1rem;
`

export const ShiftListItem = styled.div`
  ${props => props.theme.content};
  border: 1px solid #ffffff20;
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

`

export const WelfareConatainer = styled.div`
    display: flex;
    width: 100%;
    gap: 1rem;

  @media (max-width: 1300px) {
  
    flex-direction:column;
  
  }


`

export const EmployeeCountCard = styled(Box) <{ color?: string }>`
  
  height: 100px;
  padding: 1rem;
  display: flex;
  gap: 12px;
  width: 100%;
  border-left:1.5px solid ${props => props.color ? props.color : tokens.accent.base};
  border-radius: 12px;
  align-items: center;


`